module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"is-special":"(Extra)"},"zh-TW":{"is-special":"( 加開 )"}}')
  delete Component.options._Ctor
}
